import { useEffect, useState } from 'react'

interface IUseDebounceProps {
  delay?: number
  value?: string
}

export const useDebounce = ({ value, delay = 500 }: IUseDebounceProps) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
